function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ar_report_icon");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ar_report_icon",
  fill: "#3E3E3E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.20023195,17.9999983 C10.4678699,17.9999983 12.5209319,17.0823002 14.0061404,15.5988084 L8.20023195,9.82105233 L8.20023195,1.6451962 C3.67216583,1.6451962 -2.94875235e-13,5.30500247 -2.94875235e-13,9.82105233 C-2.94875235e-13,14.3371022 3.67216583,17.9999983 8.20023195,17.9999983 L8.20023195,17.9999983 L8.20023195,17.9999983 Z M9.33044604,8.64311657 L17.9999983,8.64311657 C17.9999983,3.86888899 14.1170332,3.00381942e-12 9.33044604,3.00381942e-12 L9.33044604,8.64311657 L9.33044604,8.64311657 Z M9.79084005,9.79084005 L15.619751,15.5442203 C17.0891666,14.0675949 17.9962218,12.0337588 17.9962218,9.79084005 L9.79084005,9.79084005 L9.79084005,9.79084005 Z",
  id: "Shape"
})));

var SvgPieChart = function SvgPieChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPieChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie-chart.b4126f76.svg";
export { ForwardRef as ReactComponent };